import { Image, Result } from "antd";
import { images_folder } from "./client";

const PaymentStatusPage = (props) => {
  return (
    <>
      <div className="sign-in-intro">
        <Image width={75} preview={false} src={images_folder("uk-flag.png")} />
      </div>
      <Result
        status="success"
        title="Payment Successful!"
        subTitle="A receipt has been sent to your registered email address."
        extra={[
          <h3 key="pymnt-success-1">
            We will begin processing your application within 2 - 3 business
            days.
          </h3>,
          <p key="pymnt-success-2">
            Updates of your application process will be sent to your registered
            email.
          </p>,
          <p key="pymnt-success-3">
            You can also sign in to the portal to see updates on your
            application.
          </p>,
        ]}
      />
    </>
  );
};
export default PaymentStatusPage;
